<template>
  <div>
    <gp-select :dataObj="dataObj" :possible-values="possibleValues" :required="required"
               :label="label" :propertyName="propertyName"/>
  </div>
</template>

<script>
/*
 This component was created to support the tenant settings page since system pages can be used in many locations within the same component.
 */
import gpSelect from "./GPSelect";

export default {
    name: 'GPSelect',
    components: {
      gpSelect
    },
    data() {
      return {
        possibleValues: []
      }
    },
    props: {
      dataObj: {
        type: Object,
        default: null
      },
      propertyName: {
        type: String,
        default: null
      },
      pageList: {
        type: Array,
        default: []
      },
      label: {
        type: String,
        default: ""
      },
      required: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
    },
    beforeMount() {
      if (!this.required) this.possibleValues.push({text: "---NONE---", value: null})
      for (let i = 0; i < this.pageList.length; i++) {
        let row = this.pageList[i]
        this.possibleValues.push({text: row.text, value: row.value})
      }
    },
  };
</script>
